import { createAction, props } from '@ngrx/store';

import { Layout } from '../models/layout';
import { Panel } from '../models/panel';

export const load = createAction('[Layout] Load', props<{ layoutName: string }>());
export const loadSuccess = createAction('[Layout] Load Success', props<{ layout: Layout; panels: Panel[] }>());
export const loadFail = createAction('[Layout] Load Fail', props<{ error: any }>());
